/* eslint-disable no-console */
import { Tooltip } from '@mui/material';

function BasicInput(props) {
  const { id, className, value, disabled, onBlur, onClick, onFocus, onContextMenu, onKeyDown, onChange } = props;
  const { minLength, checked, alt, src, autoComplete, multiple, placeholder, type, max, maxLength, min } = props;

  // by ABhishek on 24th-Nov-2023: for the feed form-> Show chemical name on hover of Ions as a tooltip.
  const feedIons = {
    'Ca++' : 'Calcium',
    'Mg++' : 'Magnesium',
    'Na+' : 'Sodium',
    'K+' : 'Potassium',
    'NH4+' : 'Ammonia',
    'Ba++' : 'Barium',
    'Sr++' : 'Strontium',
    'Fe++' : 'Iron',
    'Mn++' : 'Manganese',
    'SO4--' : 'Sulfate',
    'Cl-' : 'Chloride',
    'F-' : 'Fluoride',
    'NO3-' : 'Nitrate',
    'Br-' : 'Bromide',
    'PO4---' : 'Phosphate',
    'B' : 'Boron',
    'SiO2' : 'Silica',
    'H2S' : 'Hydrogen Sulfide',
    'HCO3-' : 'Bicarbonate',
    'CO2' : 'Carbon Dioxide',
    'CO3--' : 'Carbonate'
  };

  const getFeedTooltipName = (value) => {
    return feedIons[value] ? feedIons[value] : value;
  };

  return ( // eslint-disable-next-line
    <Tooltip title={value !== undefined ? getFeedTooltipName(value) : (className === 'admin-delete-icon' ? 'Delete': (className === 'admin-edit-icon' ? 'Edit': '') ) }>
      {/* in thr above line Here we are checking className for the admin table icon tooltip */}
      {/* <Tooltip title={value !== undefined ? value : ''}> */}
      {type !== 'span' ?
        <input
          id={id}
          className={className}
          type={type}
          value={value}
          disabled={disabled}
          onBlur={onBlur}
          onClick={onClick}
          onChange={onChange}
          onFocus={onFocus}
          onContextMenu={onContextMenu}
          onKeyDown={onKeyDown}
          src={src}
          alt={alt}
          autoComplete={autoComplete}
          max={max}
          min={min}
          minLength={maxLength}
          maxLength={minLength}
          multiple={multiple}
          placeholder={placeholder}
          checked={checked}
        /> : <>
          <span
            className={className}
            onContextMenu={onContextMenu}
            alt={alt}
          >{value}
          </span>
          <input
            id={id}
            className={className}
            type='hidden'
            value={value}
            disabled={disabled}
            onBlur={onBlur}
            onClick={onClick}
            onChange={onChange}
            onFocus={onFocus}
            onContextMenu={onContextMenu}
            onKeyDown={onKeyDown}
            src={src}
            alt={alt}
            autoComplete={autoComplete}
            max={max}
            min={min}
            minLength={maxLength}
            maxLength={minLength}
            multiple={multiple}
            placeholder={placeholder}
            checked={checked}
          />
        </>
      }
    </Tooltip>
  );
}
export default BasicInput;